import { CCIPLiteHelper } from "./utils/CCIPLiteHelper";

export class CCIPHelper {
  private ccipLiteHelperL1: CCIPLiteHelper;
  private ccipLiteHelperL2: CCIPLiteHelper;
  private config: any;
  constructor(config: any) {
    this.ccipLiteHelperL1 = new CCIPLiteHelper(config.L1.rpc);
    this.ccipLiteHelperL2 = new CCIPLiteHelper(config.L2.rpc);
    this.config = config;
  }
  async getUnstakeStatus(
    txHash: string,
    unlockPeriod: number,
    BLOCK_TO_SERACH = 2000
  ) {
    const message = await this.getMessageID(txHash, "L2");
    const L1LatestBlock =
      await this.ccipLiteHelperL1.ethersUtils.getLatestBlockNumber();
    const L2LatestBlock =
      await this.ccipLiteHelperL2.ethersUtils.getLatestBlockNumber();

    if (L2LatestBlock - message.blockNumber > BLOCK_TO_SERACH) {
      if (L2LatestBlock - message.blockNumber > unlockPeriod * 3.5 + 3000) {
        return {
          state: "UNLOCKED",
          blockNumber: message.blockNumber,
          latestBlock: L1LatestBlock,
        };
      } else {
        return {
          state: "LOCKED",
          blockNumber: message.blockNumber,
          latestBlock: L1LatestBlock,
        };
      }
    }
    const status = await this.getTransferStatus(
      message.messageId,
      "L2",
      BLOCK_TO_SERACH
    );
    if (status.state === "SUCCESS") {
      if (L1LatestBlock - status.blockNumber > unlockPeriod) {
        return {
          state: "UNLOCKED",
          blockNumber: status.blockNumber,
          latestBlock: L1LatestBlock,
          unlockedAt: message.blockNumber + unlockPeriod,
        };
      } else {
        return {
          state: "LOCKED",
          blockNumber: status.blockNumber,
          latestBlock: L1LatestBlock,
          blocksUntilUnlock:
            unlockPeriod - (L1LatestBlock - status.blockNumber),
        };
      }
    } else {
      return status;
    }
  }

  async getDepositStatus(
    txHash: string,
    address: string,
    BLOCK_TO_SERACH = 2000
  ) {
    const messageId = await this.getMessageID(txHash, "L2");
    if (messageId.latestBlock - messageId.blockNumber > BLOCK_TO_SERACH) {
      return {
        state: "OUT_OF_RANGE",
      };
    }
    const status = await this.getTransferStatus(
      messageId.messageId,
      "L2",
      BLOCK_TO_SERACH
    );
    status.step = 1;
    if (status.state === "SUCCESS") {
      const vaultMessages = await this.getVaultMessage(
        address,
        BLOCK_TO_SERACH
      );
      for (const vaultMessage of vaultMessages) {
        if (vaultMessage.transactionHash === status.transactionHash) {
          const vaultStatus = await this.getTransferStatus(
            vaultMessage.messageId,
            "L1",
            BLOCK_TO_SERACH
          );
          vaultStatus.step = 2;
          vaultStatus.deposit = status;
          return vaultStatus;
        }
      }
    } else {
      return status;
    }
  }

  async getBridgeStatus(
    txHash: string,
    chain: "L1" | "L2",
    BLOCK_TO_SERACH = 2000
  ) {
    const messageId = await this.getMessageID(txHash, chain);

    const status = await this.getTransferStatus(
      messageId.messageId,
      chain,
      BLOCK_TO_SERACH
    );
    return status;
  }

  async getMessageID(txHash: string, chain: "L1" | "L2") {
    if (chain === "L1") {
      const messageId = await this.ccipLiteHelperL1.getMessageId(txHash);
      const latestBlock =
        await this.ccipLiteHelperL1.ethersUtils.getLatestBlockNumber();
      return {
        messageId: messageId.messageId,
        blockNumber: messageId.blockNumber,
        latestBlock: latestBlock,
      };
    } else {
      const messageId = await this.ccipLiteHelperL2.getMessageId(txHash);
      const latestBlock =
        await this.ccipLiteHelperL2.ethersUtils.getLatestBlockNumber();
      return {
        messageId: messageId.messageId,
        blockNumber: messageId.blockNumber,
        latestBlock: latestBlock,
      };
    }
  }
  async getVaultMessage(toAddress: string, BLOCK_TO_SERARCH?: number) {
    const vaultMessage = await this.ccipLiteHelperL1.getAddressCCIPsendStatus({
      fromAddress: this.config.L1.deploy.CCIPBridge,
      toAddress: toAddress,
      sourceRouterAddress: this.config.L1.ccip.Router,
      destinationChainSelector: this.config.L2.ccip.ChainSelector,
      BLOCKS_TO_SEARCH: BLOCK_TO_SERARCH,
    });
    return vaultMessage;
  }
  async getTransferStatus(
    messageId: string,
    chain: "L1" | "L2",
    BLOCKS_TO_SEARCH?: number
  ) {
    if (chain === "L1") {
      return await this.ccipLiteHelperL2.getTransferStatus(
        messageId,
        this.config.L2.ccip.Router,
        this.config.L1.ccip.ChainSelector,
        BLOCKS_TO_SEARCH
      );
    } else {
      return await this.ccipLiteHelperL1.getTransferStatus(
        messageId,
        this.config.L1.ccip.Router,
        this.config.L2.ccip.ChainSelector,
        BLOCKS_TO_SEARCH
      );
    }
  }
}
